import React from "react"
import {Form, Input, Button, Row, Col, Select, Checkbox} from "antd"
import PropTypes from "prop-types"
import {autobind} from "core-decorators"
import {mapPropsToFields} from "utils/form"
import ReactTelephoneInput from "react-telephone-input/lib/withStyles"
import createLanguage, {langPropTypes} from "hoc/create-lang"
import {getOrganizations} from "api/OrganizationApi"
import {replaceVietnameseStr} from "utils/string"

require("../user-search-form/index.css")

const FormItem = Form.Item

@Form.create({
  mapPropsToFields: ({initialValues = {}}) => {
    initialValues = {
      ...initialValues,
      organization: initialValues.organization
        ? initialValues.organization._id
        : "",
      phone: initialValues.phone ? initialValues.phone.phoneNumber : ""
    }
    return mapPropsToFields({initialValues})
  }
})
@createLanguage
@autobind
export default class UserForm extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func,
    lang: langPropTypes,
    isEdit: PropTypes.bool,
    initialValues: PropTypes.object
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDirty: false,
      selectOrganizations: [],
      listOrganization: [],
      phone: {}
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (err) return
      const data = {
        username: values.userName,
        email: values.email,
        password: values.password,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: this.state.phone,
        isOwner: values.isOwner,
        isAdmin: values.isAdmin,
        organization: values.organization
          ? this.state.selectOrganizations.find(
              item => item._id === values.organization
            )
          : null
      }
      // Callback submit form Container Component
      this.props.onSubmit(data)
    })
  }

  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], {force: true})
    }
    callback()
  }

  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue("password")) {
      callback("Two passwords that you enter is inconsistent!")
    } else {
      callback()
    }
  }
  handleConfirmBlur = e => {
    const value = e.target.value
    this.setState({confirmDirty: this.state.confirmDirty || !!value})
  }

  handleTelChange(telNumber, selectedCountry) {
    this.setState({
      phone: {
        phoneNumber: telNumber,
        ...selectedCountry
      }
    })
  }

  async componentWillMount() {
    const organizations = await getOrganizations(
      {page: 1, itemPerPage: 10000000},
      {}
    )
    this.setState({
      selectOrganizations: organizations.data,
      listOrganization: organizations.data
    })
  }

  onSearchOrganization = value => {
    console.log("onSearchOrganization", value)
    // const searchString = replaceVietnameseStr(value)
    // const listOrganizations = this.state.listOrganization.filter(
    //   item => replaceVietnameseStr(item.name).indexOf(searchString) > -1
    // )
    // console.log("listOrganizations:", listOrganizations)
    // this.setState({
    //   selectOrganizations: listOrganizations

    // })
  }

  render() {
    const {form: {getFieldDecorator}, lang: {t}} = this.props
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={16}>
          <Col span={12}>
            <FormItem label={t("userForm.form.email.label")}>
              {getFieldDecorator("email", {
                rules: [
                  {
                    type: "email",
                    message: "The input is not valid E-mail!"
                  },
                  {
                    required: true,
                    message: t("userForm.form.email.label")
                  }
                ]
              })(
                <Input
                  disabled={this.props.isEdit}
                  placeholder={t("userForm.form.email.label")}
                />
              )}
            </FormItem>
          </Col>
        </Row>

        {!this.props.isEdit && (
          <Row gutter={16}>
            <Col span={12}>
              <FormItem label={t("userForm.form.password.label")}>
                {getFieldDecorator("password", {
                  rules: [
                    {
                      required: true,
                      message: t("userForm.form.password.label")
                    },
                    {
                      validator: this.validateToNextPassword
                    }
                  ]
                })(
                  <Input
                    type="password"
                    disabled={this.props.isEdit}
                    placeholder={t("userForm.form.password.placeholder")}
                  />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label={t("userForm.form.confirmPassword.label")}>
                {getFieldDecorator("confirmPassword", {
                  rules: [
                    {
                      required: true,
                      message: t("userForm.form.confirmPassword.message")
                    },
                    {
                      validator: this.compareToFirstPassword
                    }
                  ]
                })(
                  <Input
                    type="password"
                    placeholder={t("userForm.form.confirmPassword.label")}
                    onBlur={this.handleConfirmBlur}
                  />
                )}
              </FormItem>
            </Col>
          </Row>
        )}

        <Row gutter={16}>
          <Col span={12}>
            <FormItem label={t("userForm.form.firstName.label")}>
              {getFieldDecorator("firstName", {
                rules: [
                  {
                    required: true,
                    message: t("userForm.form.firstName.label")
                  }
                ]
              })(
                <Input placeholder={t("userForm.form.firstName.placeholder")} />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label={t("userForm.form.lastName.label")}>
              {getFieldDecorator("lastName", {
                rules: [
                  {
                    required: true,
                    message: t("userForm.form.lastName.label")
                  }
                ]
              })(<Input placeholder={t("userForm.form.lastName.label")} />)}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <FormItem label={t("userForm.form.phone.label")}>
              {getFieldDecorator(`phone`, {
                rules: [
                  {
                    required: true,
                    message: t("userForm.form.phone.label")
                  }
                ]
              })(
                <ReactTelephoneInput
                  defaultCountry="vn"
                  flagsImagePath={
                    !this.props.isEdit
                      ? "../images/flags.png"
                      : "../../images/flags.png"
                  }
                  onChange={this.handleTelChange}
                  // onBlur={this.handleInputBlur}
                />
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label={t("userForm.form.organization.label")}>
              {getFieldDecorator(`organization`, {
                rules: [
                  {
                    required: true,
                    message: t("userForm.form.organization.label")
                  }
                ]
              })(
                <Select
                  showSearch
                  onSearch={this.onSearchOrganization}
                  filterOption={(input, option) => {
                    return (
                      replaceVietnameseStr(option.props.children)
                        .toLowerCase()
                        .indexOf(replaceVietnameseStr(input).toLowerCase()) >= 0
                    )
                  }}
                >
                  {this.state.selectOrganizations &&
                    this.state.selectOrganizations.map(item => {
                      return (
                        <Select.Option key={item._id} value={item._id}>
                          {item.name}
                        </Select.Option>
                      )
                    })}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={4}>
            <FormItem>
              {getFieldDecorator("isOwner", {
                valuePropName: "checked"
              })(<Checkbox>{t("userForm.form.isOwner.label")}</Checkbox>)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              {getFieldDecorator("isAdmin", {
                valuePropName: "checked"
              })(<Checkbox>{t("userForm.form.isAdmin.label")}</Checkbox>)}
            </FormItem>
          </Col>
        </Row>

        <FormItem>
          <Button style={{width: "100%"}} type="primary" htmlType="submit">
            Save
          </Button>
        </FormItem>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/user/user-form/index.js